export class City {
    public CITYID!: number;
    public CITYNAME!: string;
    public StateNAME!: string;
    public STATEID!: number;
}